import React, { createContext, useState, useContext, useEffect } from 'react';

const PlaceContext = createContext();

export const usePlace = () => useContext(PlaceContext);

export const PlaceProvider = ({ children }) => {
  const [selectedPlace, setSelectedPlace] = useState(() => {
    const savedPlaceName = sessionStorage.getItem('selectedPlaceName');
    const savedPlaceId = sessionStorage.getItem('selectedPlaceId');
    if (savedPlaceName && savedPlaceId) {
      return { id: savedPlaceId, name: savedPlaceName };
    }
    return null;
  });

  const changePlace = (place) => {
    if (place) {
      sessionStorage.setItem('selectedPlaceId', place.id);
      sessionStorage.setItem('selectedPlaceName', place.name_place);
      setSelectedPlace({ id: place.id, name: place.name_place });
    } else {
      sessionStorage.removeItem('selectedPlaceId');
      sessionStorage.removeItem('selectedPlaceName');
      setSelectedPlace(null);
    }
    window.location.reload(); // For now, to ensure all components refresh
  };

  useEffect(() => {
    const handleStorageChange = () => {
      const savedPlaceName = sessionStorage.getItem('selectedPlaceName');
      const savedPlaceId = sessionStorage.getItem('selectedPlaceId');
      if (savedPlaceName && savedPlaceId) {
        setSelectedPlace({ id: savedPlaceId, name: savedPlaceName });
      } else {
        setSelectedPlace(null);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <PlaceContext.Provider value={{ selectedPlace, changePlace }}>
      {children}
    </PlaceContext.Provider>
  );
};
